// ======================================
// Refer a Friend Page Module
// ======================================

import { icons } from '../components.js';
import { referralsAPI } from '../lib/api.js';

const benefits = [
  { icon: icons.award, title: '₹5,000 Cashback', desc: 'You get ₹5,000 cashback when your referral books a project' },
  { icon: icons.home, title: 'Free Add-On', desc: 'Your friend gets a free premium add-on worth ₹10,000' },
  { icon: icons.star, title: 'VIP Treatment', desc: 'Both of you get priority scheduling and dedicated designer' },
  { icon: icons.users, title: 'Unlimited Referrals', desc: 'No limits — refer as many friends as you want' }
];

export function renderReferPage() {
  return `
    <section class="page-header" style="background: linear-gradient(135deg, var(--color-accent-dark), var(--color-accent)); color: white;">
      <div class="container">
        <div class="page-header-content" style="text-align:center;">
          <p style="color: rgba(255,255,255,0.9); font-weight: 600; letter-spacing: 0.1em; text-transform: uppercase; margin-bottom: var(--space-4);">Referral Program</p>
          <h1 class="page-title" style="color:white; font-family: var(--font-heading);">Refer a Friend, Earn Rewards</h1>
          <p class="page-subtitle" style="color: rgba(255,255,255,0.85); max-width: 640px; margin: 0 auto;">
            Love your new interiors? Share the experience with friends and family — and earn exciting rewards for every referral.
          </p>
        </div>
      </div>
    </section>

    <!-- Benefits -->
    <section style="padding: var(--space-16) 0;">
      <div class="container">
        <h2 style="font-family: var(--font-heading); font-size: var(--text-3xl); text-align: center; margin-bottom: var(--space-12);">What You Get</h2>
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: var(--space-6);">
          ${benefits.map(b => `
            <div style="text-align: center; padding: var(--space-8); background: white; border-radius: var(--radius-xl); box-shadow: var(--shadow-sm); border: 1px solid var(--color-border-light); transition: transform 0.3s ease, box-shadow 0.3s ease;" onmouseover="this.style.transform='translateY(-4px)';this.style.boxShadow='var(--shadow-gold)'" onmouseout="this.style.transform='';this.style.boxShadow='var(--shadow-sm)'">
              <div style="width: 56px; height: 56px; border-radius: 50%; background: var(--color-accent-50); color: var(--color-accent-dark); display: flex; align-items: center; justify-content: center; margin: 0 auto var(--space-4);">
                ${b.icon}
              </div>
              <h3 style="font-family: var(--font-heading); margin-bottom: var(--space-2);">${b.title}</h3>
              <p style="color: var(--color-text-muted); font-size: var(--text-sm);">${b.desc}</p>
            </div>
          `).join('')}
        </div>
      </div>
    </section>

    <!-- How It Works -->
    <section style="background: var(--color-primary-50); padding: var(--space-16) 0;">
      <div class="container" style="max-width: var(--max-width-narrow);">
        <h2 style="font-family: var(--font-heading); font-size: var(--text-3xl); text-align: center; margin-bottom: var(--space-12);">How It Works</h2>
        <div style="display: flex; flex-direction: column; gap: var(--space-8);">
          ${[
      { step: 1, text: 'Fill in the referral form below with your friend\'s details' },
      { step: 2, text: 'We reach out to your friend for a free consultation' },
      { step: 3, text: 'When they book a project, you both get rewarded!' }
    ].map(s => `
            <div style="display: flex; align-items: center; gap: var(--space-6); background: white; padding: var(--space-6); border-radius: var(--radius-lg); box-shadow: var(--shadow-sm);">
              <div style="width: 48px; height: 48px; border-radius: 50%; background: var(--color-primary); color: white; display: flex; align-items: center; justify-content: center; font-family: var(--font-heading); font-size: var(--text-xl); font-weight: var(--font-bold); flex-shrink: 0;">${s.step}</div>
              <p style="font-size: var(--text-lg);">${s.text}</p>
            </div>
          `).join('')}
        </div>
      </div>
    </section>

    <!-- Referral Form -->
    <section style="padding: var(--space-20) 0;">
      <div class="container" style="max-width: 640px;">
        <h2 style="font-family: var(--font-heading); font-size: var(--text-3xl); text-align: center; margin-bottom: var(--space-3);">Refer Now</h2>
        <p style="text-align: center; color: var(--color-text-muted); margin-bottom: var(--space-10);">Fill in your friend's details and we'll take it from here.</p>

        <form id="referral-form" style="display: flex; flex-direction: column; gap: var(--space-5);">
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: var(--space-4);">
            <div class="form-group">
              <label class="form-label">Your Name *</label>
              <input type="text" name="referrer_name" class="form-input" placeholder="Your full name" required>
            </div>
            <div class="form-group">
              <label class="form-label">Your Phone *</label>
              <input type="tel" name="referrer_phone" class="form-input" placeholder="+91 82205 95978" required>
            </div>
          </div>
          <div style="border-top: 1px solid var(--color-border); padding-top: var(--space-5); margin-top: var(--space-2);">
            <p style="font-weight: var(--font-semibold); margin-bottom: var(--space-4); color: var(--color-primary);">Friend's Details</p>
          </div>
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: var(--space-4);">
            <div class="form-group">
              <label class="form-label">Friend's Name *</label>
              <input type="text" name="friend_name" class="form-input" placeholder="Friend's full name" required>
            </div>
            <div class="form-group">
              <label class="form-label">Friend's Phone *</label>
              <input type="tel" name="friend_phone" class="form-input" placeholder="+91 82205 95978" required>
            </div>
          </div>
          <div class="form-group">
            <label class="form-label">Friend's Email (Optional)</label>
            <input type="email" name="friend_email" class="form-input" placeholder="friend@email.com">
          </div>
          <div class="form-group">
            <label class="form-label">Message (Optional)</label>
            <textarea name="message" class="form-input" rows="3" placeholder="Any message for your friend?"></textarea>
          </div>
          <button type="submit" class="btn btn-primary btn-lg" id="referral-submit">Submit Referral</button>
        </form>
      </div>
    </section>
  `;
}

export function initReferPage() {
  const form = document.getElementById('referral-form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = document.getElementById('referral-submit');
    btn.disabled = true;
    btn.innerHTML = '<span class="spinner"></span> Submitting...';

    try {
      const formData = new FormData(form);
      const data = Object.fromEntries(formData.entries());

      await referralsAPI.create(data);

      form.innerHTML = `
              <div style="text-align: center; padding: var(--space-12);">
                <div style="width: 72px; height: 72px; border-radius: 50%; background: var(--color-primary-50); color: var(--color-primary); display: flex; align-items: center; justify-content: center; margin: 0 auto var(--space-6); font-size: var(--text-3xl);">
                  ${icons.check}
                </div>
                <h3 style="font-family: var(--font-heading); font-size: var(--text-2xl); margin-bottom: var(--space-3);">Referral Submitted!</h3>
                <p style="color: var(--color-text-muted);">We'll reach out to your friend within 24 hours. Thank you for spreading the word!</p>
              </div>
            `;
    } catch (error) {
      console.error('Referral failed:', error);
      alert('Failed to submit referral. Please try again.');
      btn.innerHTML = 'Submit Referral';
      btn.disabled = false;
    }
  });
}
